import { useEffect } from "react";
import { useNavigate } from "react-router-dom"

import styles from './ChamProjects.module.css'

// Base component 
export default function ChamProjects({ children }) {
    const navigate = useNavigate();

    useEffect(() => {
        document.querySelector('cham-projects').addEventListener('gotoviz', function (e) {
        document.querySelector('cham-projects').setAttribute("active", "0");
        navigate(`/visualizer/spec/${encodeURIComponent(e.value.specifier)}/sel/${e.value.sel}`);
      });
    }, [navigate]);

    return (
            <cham-projects styles={styles.chamProjects}>{children}</cham-projects>
    );
}

// Open projects dialog 
export function ChamProjectsOpenButton({ className, title }) {

    const handleClick = function () {
        document.querySelector('cham-projects').setAttribute("active", "1");
    }

    return (
        <button onClick={handleClick} className={className}>{title}</button>
    )
}

// Saves a project
export function ChamProjectsSaveButton({ className, title }) {

    const handleClick = function () {
        let saveData = document.getElementById("chamViz").getSaveData();
        document.querySelector('cham-projects').saveProject(saveData.spec, saveData.sel);
    }

    return (
        <button onClick={handleClick} className={className}>{title}</button>
    )
}